import logo from '../assets/logo_3.png';

function ProfileImage({ profile, size = 46 }) {
    return (
        <img
            src={profile.image ? profile.image : logo}
            className="header-logo"
            style={{
                borderRadius: "1000px",
                height: `${size}px`,
                width: `${size}px`,
                border: "1px solid #2c3e50",
                background: profile.background ? profile.background : "white",
            }}
        />
    )
}

export default ProfileImage